var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93187 8L4 10.9586L24.438 11.1533L23.4258 14.4623H15.1338L14.5109 16.7591L22.6472 16.9927L21.2457 21.0024L9.83942 20.8467L12.0973 13.4891L9.45012 11.6594L5.51825 24H20.3504L24.2044 22.0925L25.4501 17.8491L23.0754 15.9416L26.8127 13.9562L28.0584 9.9854L25.5669 8H7.93187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlast);
export default __webpack_public_path__ + "static/media/BLAST.c3f716e44d2051ab17bf01cffdb64e77.svg";
export { ForwardRef as ReactComponent };